/**
 * Adam Decor · anime.js v3 Theme Animations
 */
(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    if (typeof anime === 'undefined') {
      console.log('[Adam Decor] Waiting for anime.js...');
      setTimeout(init, 500);
      return;
    }

    // 1. Hero heading entrance
    var heading = document.querySelector('.collection__title, .page-title, h1');
    if (heading) {
      anime({
        targets: heading,
        opacity: [0, 1],
        translateY: [30, 0],
        duration: 800,
        easing: 'easeOutCubic'
      });
    }

    // 2. Product cards stagger entrance
    var cards = document.querySelectorAll('.card-wrapper, .grid__item');
    if (cards.length) {
      anime({
        targets: cards,
        opacity: [0, 1],
        translateY: [40, 0],
        duration: 500,
        delay: anime.stagger(80),
        easing: 'easeOutCubic'
      });
    }

    // 3. Product card hover
    document.querySelectorAll('.card-wrapper').forEach(function(card) {
      card.addEventListener('mouseenter', function() {
        anime({ targets: card, scale: 1.02, duration: 300, easing: 'easeOutCubic' });
      });
      card.addEventListener('mouseleave', function() {
        anime({ targets: card, scale: 1, duration: 300, easing: 'easeOutCubic' });
      });
    });

    // 4. Announcement bar entrance
    var bar = document.querySelector('.announcement-bar');
    if (bar) {
      anime({
        targets: bar,
        translateY: [-30, 0],
        opacity: [0, 1],
        duration: 600,
        easing: 'easeOutCubic'
      });
    }

    // 5. Scroll reveal
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !entry.target.dataset.animated) {
          entry.target.dataset.animated = 'true';
          var items = entry.target.querySelectorAll('.card-wrapper, .grid__item');
          if (items.length) {
            anime({
              targets: items,
              opacity: [0, 1],
              translateY: [60, 0],
              duration: 600,
              delay: anime.stagger(60),
              easing: 'easeOutCubic'
            });
          }
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.collection, .product-grid').forEach(function(el) {
      observer.observe(el);
    });

    // 6. Button click pulse
    document.querySelectorAll('.button--primary, .product-form__submit').forEach(function(btn) {
      btn.addEventListener('click', function() {
        anime({ targets: btn, scale: [1, 1.05, 1], duration: 400, easing: 'easeInOutCubic' });
      });
    });

    console.log('[Adam Decor] anime.js v3 animations initialized');
  }
})();
